/**
 * This timer tries to return almost accurate time entry
 * @param callback Method to run within the time interval
 * @param interval Time interval needs to run the execution in `milliseconds`
 * @returns A function 
 * @description When using setTimeout or setInterval functions in a browser for longer 
 * durations it can cause small delays due to the single thread execution of JS and browser performance 
 * and they will accumulates to a larger error after all. In this function, it tries to compare each 
 * cycle with the system clock and trying to minimize the deviation by reducing that from the original 
 * interval. Still there can be small delays, but that is bearable as it is no more than 200 or 300 milliseconds max 
 */
export const precisionTimer = function(callback: () => void, interval: number = 1000): () => void {
  let counter = 1;
  let timeoutId: any;
  const startTime = Date.now();

  function main() {
    const nowTime = Date.now();
    const nextTime = startTime + counter * interval;
    const deviation = (nowTime - nextTime);

    //replace the timeoutId with deviation corrected timeout
    timeoutId = setTimeout(main, interval - deviation);

    counter += 1;
    callback();
  }

  timeoutId = setTimeout(main, interval);

  return () => {
    clearTimeout(timeoutId);
  };
}